export default __webpack_public_path__ + "static/media/ladrillos-detalle.34089d74.png";